export const readToken = <T>(token: string): T => {
  // split at the right-most .
  const [data, _] = token.split(".");
  return JSON.parse(atob(data)) as T;
};
